define("CFCA/CFCAAuthenticationProvider", [
    "dojo/_base/declare",
    "dojo/dom",
    "dijit/registry",
    "csi/locale",
    "csi/authentication/AuthenticationProvider",
    "./CFCAAgent"
], function (declare, dom, registry, locale, AuthenticationProvider, CFCAAgent) {

    var CFCA_SIGNATURE = "CFCASignature";

    /**
     * Use calls to CFCAAgent to sign a username
     */
    function onClick(event) {
        var CryptoKit = CFCAAgent.loadObject();
        if (!CFCAAgent.isSupported(CryptoKit))
            throw new Error(locale.resource("CFCAPluginNotInstalled"));

        var form = registry.getEnclosingWidget(event.target);
        var loginId = form.getLoginIdFormField().value;

        var signature = "";
        var inputField = dom.byId(CFCA_SIGNATURE);

        CryptoKit.selectCertificate("", "", "");
        CryptoKit.signMsgPKCS7Attached(loginId, "SHA-1")
            .then(function (response) {
                signature = response.result;
                inputField.value = signature;
            })
            .catch(function (response) {
                CFCAAgent.ShowErrorInfo(response, CryptoKit);
            });
    }

    /**
     * CFCA authentication provider
     */
    return declare(AuthenticationProvider, {
        getFieldDefinitions: function () {
            return [{
                id: CFCA_SIGNATURE,
                type: "text",
                readOnly: true
            }, {
                id: "CFCASignButton",
                type: "button",
                value: locale.resource("CFCASignButtonText"),
                onClick: onClick
            }
            ];
        }
    });
});